import React from 'react'
import CrossIcon from '../assets/icon-no-cross.svg'
import { onDesktop } from '../simple-components/styledElements'

const Invalid = () => {
  return (
    <div
      css={`
        margin-block: 3em;
        font-size: 1.5rem;
        font-family: ${(props) => props.theme.font.family.medium};
        font-weight: 700;
        color: ${(props) => props.theme.color.error};
        text-align: center;
        ${onDesktop`
          margin-block: 3em;
        `}
      `}
    >
      <CrossIcon css='height: 6rem; margin-bottom: 1rem;' />
      <div>Invalid token.</div>
    </div>
  )
}

export default Invalid
